export default __webpack_public_path__ + "static/media/kitchen-pack-11.b7674d80.png";